import { ROLE_CLINICIAN } from "constants/AppConstants";

// Remembers the email "Accept" deep link (/job/apply?...) across the login page,
// so a logged out clinician lands back on it after logging in.
const STORAGE_KEY = "postLoginRedirect";
// only these paths may be restored (prevents an open redirect)
const ALLOWED_PREFIXES = ["/job/apply"];

const isAllowed = (path) =>
  typeof path === "string" &&
  ALLOWED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}?`));

export const savePostLoginRedirect = (path) => {
  try {
    if (isAllowed(path)) sessionStorage.setItem(STORAGE_KEY, path);
  } catch (e) {}
};

// path (without the router basename) of the current page
export const currentRouterPath = () => {
  const basename = process.env.REACT_APP_BASENAME || "";
  let pathname = window.location.pathname;
  if (basename && basename !== "/" && pathname.startsWith(basename)) {
    pathname = pathname.slice(basename.length) || "/";
  }
  return `${pathname}${window.location.search}`;
};

export const clearPostLoginRedirect = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
};

// saved path when the logged in user can use it (clinician with completed signup), else null
export const getPostLoginRedirect = (user) => {
  if (!user || !ROLE_CLINICIAN.includes(user.roles) || !user.clinicianId?.isSignupCompleted) {
    return null;
  }
  try {
    const path = sessionStorage.getItem(STORAGE_KEY);
    return isAllowed(path) ? path : null;
  } catch (e) {
    return null;
  }
};
